var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import JobSummary from '@/app/components/jobs/JobSummary.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import Avatar from 'common/UIToolKit/Avatar.vue';
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue';
import { namespace } from 'vuex-class';
import UiInputHint from 'ui/v1/controls/UiInputHint.vue';
import Modal from 'ui/v1/Modal.vue';
import TrailLoader from 'ui/v1/loaders/TrailLoader.vue';
import { parse } from 'papaparse';
var importModule = namespace('candidates/import');
var ImportCandidatesView = /** @class */ (function (_super) {
    __extends(ImportCandidatesView, _super);
    function ImportCandidatesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.results = null;
        _this.importCandidates = null;
        _this.nameField = 'name';
        _this.phoneField = 'phone';
        _this.emailField = 'email';
        _this.previewLimit = 6;
        return _this;
    }
    Object.defineProperty(ImportCandidatesView.prototype, "previewList", {
        get: function () {
            return (this.importCandidates) ? this.importCandidates.slice(0, this.previewLimit) : [];
        },
        enumerable: false,
        configurable: true
    });
    ImportCandidatesView.prototype.mounted = function () {
        this.setImported(false);
    };
    ImportCandidatesView.prototype.clearFile = function () {
        this.file = null;
        this.results = null;
    };
    ImportCandidatesView.prototype.onFileSelected = function (event) {
        var _this = this;
        var _a;
        if (event.target) {
            this.file = ((_a = event.target.files) !== null && _a !== void 0 ? _a : this.file)[0];
        }
        this.setImported(false);
        parse(this.file, {
            header: true,
            dynamicTyping: true,
            complete: function (results) {
                var _a, _b, _c;
                _this.results = results;
                _this.nameField = (_a = _this.nameField) !== null && _a !== void 0 ? _a : _this.results.meta.fields[0];
                _this.emailField = (_b = _this.emailField) !== null && _b !== void 0 ? _b : _this.results.meta.fields[1];
                _this.phoneField = (_c = _this.phoneField) !== null && _c !== void 0 ? _c : _this.results.meta.fields[2];
                _this.importCandidates = results.data.map(function (item) {
                    var _a, _b;
                    return ({
                        name: item[_this.nameField],
                        email: item[_this.emailField],
                        phone: (_b = (_a = item[_this.phoneField]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : null,
                    });
                }).filter(function (item) { return item.email; });
            },
        });
    };
    ImportCandidatesView.prototype.importCandidatesToPipeline = function () {
        this.importCandidatesToJob({
            jobId: this.jobId,
            candidates: this.importCandidates,
        });
    };
    __decorate([
        importModule.State,
        __metadata("design:type", Boolean)
    ], ImportCandidatesView.prototype, "imported", void 0);
    __decorate([
        importModule.State,
        __metadata("design:type", Boolean)
    ], ImportCandidatesView.prototype, "importing", void 0);
    __decorate([
        importModule.State,
        __metadata("design:type", Array)
    ], ImportCandidatesView.prototype, "newCandidates", void 0);
    __decorate([
        importModule.State,
        __metadata("design:type", Array)
    ], ImportCandidatesView.prototype, "duplicateCandidates", void 0);
    __decorate([
        importModule.State,
        __metadata("design:type", Array)
    ], ImportCandidatesView.prototype, "ignoredCandidates", void 0);
    __decorate([
        importModule.Action,
        __metadata("design:type", Function)
    ], ImportCandidatesView.prototype, "importCandidatesToJob", void 0);
    __decorate([
        importModule.Mutation,
        __metadata("design:type", Function)
    ], ImportCandidatesView.prototype, "setImported", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], ImportCandidatesView.prototype, "jobId", void 0);
    ImportCandidatesView = __decorate([
        Component({
            components: {
                Modal: Modal,
                UiInputHint: UiInputHint,
                Avatar: Avatar,
                JobSummary: JobSummary,
                Icon: Icon,
                VueMultiselect: VueMultiselect,
                TrailLoader: TrailLoader,
            },
        })
    ], ImportCandidatesView);
    return ImportCandidatesView;
}(Vue));
export default ImportCandidatesView;
